<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				<span v-if="order!=null" class="red">

					订单编号:{{order.OrderCode }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					借书数量:{{order.BookNums }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					客户信息:{{order.CustomerName +' '+ order.CustomerPhone}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					收货地址:{{order.Destination }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					订单时间:{{order.OrderDate }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">

			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>书籍名称</th>
							<th>借出数量</th>
							<td style="width: 30rem;">
								借出详情
							</td>
							<td style="width: 30rem;">
								还入详情
							</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index_i) in books">
							<td>{{index_i+1}}</td>
							<td>
								{{i.BooksName}}
							</td>
							<td>
								{{i.BooksCount}}
							</td>
							<td>
								<p v-for="(y,index_y) in i.books" class="borrowBooks">
									编号: <span class="red"> {{ y.BooksNumCode}} </span>位置:<span
										class="red">{{y.ShopName+' ' +y.CurrentPlace}}</span>

								</p>
							</td>
							<td>
								<p v-for="(y,index_y) in i.books" class="borrowBooks">
									编号: <span class="red"> {{ y.ReturnBooksNumCode==''?' 无 ':y.ReturnBooksNumCode}}
									</span>
									位置: <span
										class="red">{{ y.ReturnShopName==''||  y.ReturnPlace==''?'无':y.ReturnShopName+' ' +y.ReturnPlace}}</span><br />
									时间: <span class="red"> {{ y.ReturnDate==''?' 无 ':y.ReturnDate}} </span>
									备注: <span class="red"> {{ y.Remarks==''?' 无 ':y.Remarks}} </span>
								</p>
							</td>
						</tr>

					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<script>
	export default {
		name: 'borrowOrderDetail',
		data() {
			return {
				order: null,
				searchBookCode: '',
				getData: {},
				books: [],
				borrowCount: 0,
				OperatorID: this.$store.state.user.UserID,
				ShopID: this.$store.state.shopID,
				orderID: 0
			}
		},
		created() {
			this.getData =()=> {
				this.orderID = this.$route.params.orderID;
				this.$request.request({
					url: 'weChatOrder/getOrderByOrderID',
					data: {
						OrderID: this.orderID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.order = res.order;
						this.books = res.order.books;
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}
			this.getData();

		},
		methods: {},
		computed: {


		},
		watch: {
			$route(n, o) {
				if (n.path.indexOf('orderDetail') == -1) return;
				let nbooksid = n.params.orderID;
				let obooksid = o.params.orderID;
				if (nbooksid != obooksid)
					this.getData();
			}

		}

	}
</script>

<style>
</style>
